/**
 * Message protocol between SolutionDesk and the translation runtime baked into the copy of a
 * user-authored HTML field (MLT-001-F3).
 *
 * DUPLICATED from the Lambda layer: amplify/backend/function/amplifysnsdemocommonlibs/opt/common/
 * HtmlTranslationRuntime.js (RUNTIME_MESSAGE / RUNTIME_MARKER_KIND / RUNTIME_VIEW). The CRA bundle
 * cannot import the layer - change one side and the other must follow.
 *
 *   runtime -> parent  READY     { trSources, ondmdSources }  (on load, and in answer to PING)
 *   parent  -> runtime PING      ask for READY again (the parent's listener may mount late)
 *   parent  -> runtime APPLY     { kind, dict, view? }        dict = { [sourceText]: translated }
 *   parent  -> runtime SET_VIEW  { kind, view }                swap original / translation (on-demand)
 */
export const RUNTIME_MESSAGE = {
    READY: 'SDESK_TR_READY',
    PING: 'SDESK_TR_PING',
    APPLY: 'SDESK_TR_APPLY',
    SET_VIEW: 'SDESK_TR_SET_VIEW'
};

export const RUNTIME_MARKER_KIND = {
    TR: 'TR',
    ONDMD: 'ONDMD'
};

export const RUNTIME_VIEW = {
    ORIGINAL: 'original',
    TRANSLATION: 'translation'
};

/** Origin the HTML field iframes are served from (CloudFront). '' when unusable. */
export const getHtmlContentOrigin = () => {
    try {
        return new URL(process.env.REACT_APP_CLOUD_FRONT_URL).origin;
    } catch (error) {
        return '';
    }
};
